<template>
  <div class="top">
    <div class="main">
      <div class="top_left">
        <span v-if="!isLogin">您好！请</span>
        <span v-if="isLogin">您好！</span>
        <ul v-if="!isLogin">
          <li class="lr">
            <router-link :to="{path:'/login'}">登录</router-link>
          </li>
          <li>|</li>
          <li>
            <router-link :to="{path:'/register'}">注册</router-link>
          </li>
        </ul>
        <ul v-if="isLogin">
          <li><a>欢迎{{ shopInfo.shopName }}</a></li>
        </ul>
      </div>
      <div class="top_right">
        <ul>
          <li><a v-if="getToken&&getToken!='null'" style="cursor: pointer;" @click="goLinkRegister"><i class="el-icon-link"></i>
            招行商户注册</a></li>
          <li><a @click="$router.push('/')" href="javascript:void(0)"><i class="el-icon-house"></i>
            首页</a></li>
          <li><a @click="$router.push('/userInfoCenter')" href="javascript:void(0)"><i class="el-icon-s-shop"></i>
            门店信息</a>
          </li>
          <li><a @click="$router.push('/userInfoPayment')" href="javascript:void(0)"><i class="el-icon-wallet"></i>
            收支明细</a>
          </li>
          <li><a @click="$router.push('/changePassword')" href="javascript:void(0)"><i class="el-icon-edit"></i>
            修改密码</a>
          </li>
          <li><a href="./static/brochure.pdf" download="问题.pdf"><i class="el-icon-document"></i>问题手册</a></li>

          <!--          <li><a @click="$router.push('/')" href="javascript:void(0)"><i class="el-icon-pie-chart"></i> 数据统计</a></li>-->
          <li><a class="fuwu" href=""><i class="el-icon-headset"></i> 客户服务</a></li>
          <li>
            <a @click="outLogin" href="javascript:void(0)" style="color:#f00;">
              <i class="el-icon-switch-button"></i> 退出</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth'
import {removeToken} from '../../utils/auth'
//  import.meta.env.VITE_APP_BASE_API;

export default {
  name: 'topbar',
  data () {
    return {
      isLogin: false,
      getToken: getToken(),
      address:''
    }
  },
  computed: {
    shopInfo () {
      return this.$store.state.shopInfo
    },
  },
  watch: {
    shopInfo: {
      handler (nowValue) {
        if (Object.keys(nowValue).length !== 0) {
          this.isLogin = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
  //  if (process.env.NODE_ENV == 'production'){
  //   this.address='http://testboot.jiedilia.com:3000'//需更换生产地址
  //  }
  //  else{
  //   this.address='http://testboot.jiedilia.com:3000'
  //   // this.address='http://192.168.10.14:3000'
  //  }
   if (process.env.NODE_ENV === 'development') {
      this.address='http://192.168.10.14:3000'
    } else {
      if (window.location.href.search('test') !== -1) {
        this.address = 'http://testboot.jiedilia.com:3000'
      } else {
        this.address = 'https://s.sisbro.cn'//需更换生产地址
      }
    }
  },
  methods: {
    outLogin () {
      this.$confirm('即将退出登录, 是否继续?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        location.reload() // 为了重新实例化vue-router对象 避免bug
      }).catch(() => {
      })

    },
    goUserCenter () {
      this.$router.push('/userInfoCenter')
    },
    goLinkRegister(){
      // console.log(this.shopInfo.shopName,9999);
      // return
      if(!this.getToken&&this.getToken!='null'){
        this.$message({
          message: '请先登录',
        })
        return
      }
      window.open(`${this.address}/jdl/ZHJdlMerchantExplicitRegistList?token=${this.getToken}&shopName=${this.shopInfo.shopName}&shopType=${this.shopInfo.shopType}&shopId=${this.shopInfo.id}&shopCode=${this.shopInfo.shopCode}`, '_blank');
    }
  }
}
</script>

<style scoped>
@import "../../assets/style/index.css";

</style>



// WEBPACK FOOTER //
// src/components/top/topbar.vue